import { useState, useCallback } from 'react';

interface ConfirmDialogState {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => boolean | void | Promise<boolean | void>;
  danger?: boolean;
}

export function useConfirmDialog() {
  const [state, setState] = useState<ConfirmDialogState>({
    open: false,
    title: '',
    message: '',
    onConfirm: () => undefined,
    danger: false,
  });

  const confirm = useCallback((
    title: string,
    message: string,
    onConfirm: () => boolean | void | Promise<boolean | void>,
    danger = false
  ) => {
    setState({
      open: true,
      title,
      message,
      onConfirm,
      danger,
    });
  }, []);

  const close = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  return {
    dialogProps: {
      ...state,
      onClose: close,
    },
    confirm,
    close,
  };
}